import { getProductURL } from "@utils/urls"
import React from "react"

interface ProductMetaDataProps {
  description: string
  images: Array<string>
  keywords: string
  name: string
  price: string
  ratingValue?: string
  reviewAuthor?: string
  reviewBody?: string
  reviewCount?: string
  reviewRating?: string
  sku: string
  url: string
}

const ProductMetaData: React.FC<ProductMetaDataProps> = ({
  description,
  images,
  keywords,
  name,
  price,
  ratingValue,
  reviewAuthor,
  reviewBody,
  reviewCount,
  reviewRating,
  sku,
  url,
}) => {
  const formatUrl = (productUrl) => {
    return `https://www.urbanarmorgear.com${getProductURL(productUrl)}`
  }

  const renderImage = (imageUrl: string) => (
    <link href={imageUrl} itemProp="image" key={imageUrl} />
  )

  const showRating = !!(ratingValue && reviewCount)
  const showReview = !!(
    showRating &&
    reviewAuthor &&
    reviewRating &&
    reviewBody
  )

  return (
    <div>
      <div itemScope itemType="http://schema.org/Product">
        <div itemProp="brand" itemScope itemType="http://schema.org/Thing">
          <meta content="Urban Armor Gear" itemProp="name" />
        </div>
        <meta content={name} itemProp="name" />
        <meta content={description} itemProp="description" />
        <meta content={keywords} itemProp="keywords" />
        <meta content={sku} itemProp="sku" />
        {images && images.length > 0 && images?.map(renderImage)}
        <div itemProp="offers" itemScope itemType="http://schema.org/Offer">
          <link href={formatUrl(url)} itemProp="url" />
          <meta content={price} itemProp="price" />
          <meta content="USD" itemProp="priceCurrency" />
          <meta content="https://schema.org/InStock" itemProp="availability" />
          <meta
            content="https://schema.org/NewCondition"
            itemProp="itemCondition"
          />
          <div
            itemProp="seller"
            itemScope
            itemType="http://schema.org/Organization"
          >
            <meta content="Urban Armor Gear" itemProp="name" />
          </div>
        </div>
        {showRating && (
          <div
            itemProp="aggregateRating"
            itemScope
            itemType="http://schema.org/AggregateRating"
          >
            <meta content={reviewCount} itemProp="reviewCount" />
            <meta content={ratingValue} itemProp="ratingValue" />
          </div>
        )}
        {showReview && (
          <div itemProp="review" itemScope itemType="http://schema.org/Review">
            <div
              itemProp="author"
              itemScope
              itemType="http://schema.org/Person"
            >
              <meta content={reviewAuthor} itemProp="name" />
            </div>
            <div
              itemProp="reviewRating"
              itemScope
              itemType="http://schema.org/Rating"
            >
              <meta content={reviewRating} itemProp="ratingValue" />
              <meta content="5" itemProp="bestRating" />
            </div>
            <meta content={reviewBody} itemProp="description" />
          </div>
        )}
      </div>
    </div>
  )
}

export default ProductMetaData
